import { render, staticRenderFns } from "./InitialSession.vue?vue&type=template&id=7bb7af10&lang=pug&"
import script from "./InitialSession.vue?vue&type=script&lang=ts&"
export * from "./InitialSession.vue?vue&type=script&lang=ts&"
import style0 from "./InitialSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports